import template from './orgSelect.component.html';

/* @ngInject */
function orgSelectController(Organization) {
  const vm = this;

  vm.$onInit = init;

  async function init() {
    vm.updatedOrg = vm.currentOrg;
    const { byId } = await Organization.model;
    vm.organizations = _.cloneDeep(byId);
    _.forEach(vm.filterOrg, (fOrg) => {
      delete vm.organizations[fOrg.id];
    });

    // Sort by name
    vm.organizations = Object.fromEntries(
      Object
        .entries(vm.organizations)
        .sort(([, orgA], [, orgB]) => orgA.name.toLowerCase() > orgB.name.toLowerCase() ? 1 : -1)
    );
  }

}

export default {
  name: 'orgSelect',
  template,
  controller: orgSelectController,
  bindings: {
    updatedOrg: '=',
    currentOrg: '=',
    filterOrg: '<?',
    showAllOpt: '=?'
  }
};
